import { useContext, useRef } from "react";
import { MSG_GLOBAL_ERROR } from "../constants";
import { SnackbarContext } from "../../components/alerts/snackbar";

export const useCopyToClipboard = () => {
  const ref = useRef(null);
  const { showSnackbar } = useContext(SnackbarContext);

  const copyToClipboard = ({
    value,
    successMsg,
  }: {
    value: any;
    successMsg?: string;
  }) => {
    let element = ref?.current;
    if (value && !element) {
      element = document.createElement("textarea");
      element.value = value;
      document.body.appendChild(element);
    }
    if (element?.select && typeof element.select === "function") {
      element.select();
      document.execCommand("copy");
      showSnackbar({
        text: successMsg ?? "Berhasil disalin",
        type: "success",
      });
      if (element) {
        element.remove();
      }
    } else {
      showSnackbar({
        text: MSG_GLOBAL_ERROR,
        type: "danger",
      });
    }
  };

  return { copyToClipboard };
};
